import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, EffectCards } from 'swiper/modules';
import { useTranslation } from '../../../shared/i18n';
import 'swiper/css';
import 'swiper/css/effect-cards';
import * as S from '../Conecta2ProductPage.styles';

const ImageGallery = ({ images }) => {
  const t = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <S.Section>
      <S.Container>
        <S.SectionTitle>{t('conecta2Product.gallery.title')}</S.SectionTitle>
        <S.SwiperGalleryContainer>
          <S.MainSwiperWrapper>
            <Swiper
              effect="cards"
              grabCursor={true}
              cardsEffect={{
                perSlideOffset: isMobile ? 8 : 12,
                perSlideRotate: isMobile ? 2 : 3,
                rotate: true,
                slideShadows: false,
              }}
              modules={[Keyboard, EffectCards]}
              keyboard={{ enabled: true }}
              centeredSlides={true}
              className="main-swiper"
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <S.SwiperImage
                    src={image.src}
                    alt={image.alt}
                    loading={index === 0 ? 'eager' : 'lazy'}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </S.MainSwiperWrapper>
        </S.SwiperGalleryContainer>
      </S.Container>
    </S.Section>
  );
};

export default ImageGallery;
